import axios from "axios";
axios.defaults.timeout = 11000;
import { Notify } from "vant";
// response拦截器
axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    console.log(error);
    if (error.response) {
      const body = error.response.data;
      console.log("错误状态码:", status);
      console.log("错误body:", body);
      if (body.code == "SESSION_ERROR") {
        // 清空登录记录
        window.localStorage.removeItem("sessionId_AI");
        window.localStorage.removeItem("userId_AI");
        window.localStorage.removeItem("sessionId");
        Notify({ type: "danger", message: "登录超时！" });
        setTimeout(() => {
          // 跳转并刷新到根下的DesktopPage
          window.location.href = window.location.origin + "/#/DesktopPage";
          window.location.reload();
        }, 1000);
      }
    }
    return Promise.reject(error);
  }
);

const handleStatus = (result) => {
  if (result.status === 200) {
    let a = {};
    a.code = "SUCCESS";
    if (result.data.bizResp) {
      a.data = JSON.parse(result.data.bizResp);
    }
    a.originalData = {};
    for (let i in result.data) {
      if (i == "bizResp") {
        a.originalData[i] = JSON.parse(result.data[i]);
      } else {
        a.originalData[i] = result.data[i];
      }
    }
    return { res: a, headers: result.headers };
  } else if (result.status === 500) {
    let a = JSON.parse(result.data.bizResp);
    a.code = "SUCCESS";
    return { res: a, headers: result.headers };
  } else {
    switch (result.status) {
    }
    return Promise.reject(result);
  }
};

export default {
  post(url, params) {
    console.info("post请求地址：" + url);
    return axios
      .post(url, JSON.stringify(params), {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then(handleStatus)
      .catch((error) => {
        return Promise.resolve(error.data);
      });
  },

  post2(url, formData) {
    console.info("post请求地址：" + url);
    return axios
      .post(url, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          appId: window.localStorage.getItem("appId_AI"),
          sessionId: window.localStorage.getItem("sessionId_AI") || "",
        },
      })
      .then(handleStatus)
      .catch((error) => {
        return Promise.resolve(error.data);
      });
  },

  post_auth(url, params) {
    console.info("post请求地址：" + url);
    return axios
      .post(url, JSON.stringify(params), {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then(handleStatus)
      .catch((error) => {
        return Promise.resolve(error.data);
      });
  },
};
